import React from 'react';
import { Outlet } from 'react-router-dom';
import { baseConfig } from '../../config';
import SideBar from '../SideBar';
import Header from '../Header';
import Footer from '../Footer';
import { Grid, View, useBreakpointValue } from '@aws-amplify/ui-react';
import Modal from '../Modal';
import GlobalMessage from '../GlobalMessage';

const Layout = () => {
  const isDesktop = useBreakpointValue({
    base: false,
    small: false,
    medium: false,
    large: true,
  }) as boolean;

  const contentPaddingX = isDesktop ? 'xl' : 'medium';
  // On mobile a fixed 56px top bar (.btn-sidebar-nav) carries the hamburger;
  // page content clears it with 56px + a little breathing room.
  // Desktop has no top bar, so 'small' is enough.
  const contentPaddingTop = isDesktop ? 'small' : '72px';
  const headerPaddingLeft = isDesktop ? '0' : 'large';

  return (
    <Grid
      templateColumns={isDesktop ? 'minmax(240px, 280px) minmax(0, 1fr)' : 'minmax(0, 1fr)'}
      templateRows="auto 1fr auto"
      minHeight="100dvh"
      gap="0"
    >
      {isDesktop ? (
        <View
          columnStart="1"
          rowStart="1"
          rowEnd="4"
          padding="0"
          backgroundColor="background.tertiary"
          position="sticky"
          top="0"
          alignSelf="start"
          height="100dvh"
          overflow="auto"
        >
          <SideBar />
        </View>
      ) : (
        <SideBar />
      )}
      <View
        columnStart={isDesktop ? '2' : '1'}
        rowStart="1"
        paddingTop="0"
        paddingBottom="0"
        paddingRight="0"
        paddingLeft={headerPaddingLeft}
        backgroundColor="background.primary"
      >
        {baseConfig.header && <Header />}
      </View>
      <View
        columnStart={isDesktop ? '2' : '1'}
        rowStart="2"
        paddingRight={contentPaddingX}
        paddingLeft={contentPaddingX}
        paddingTop={contentPaddingTop}
        paddingBottom="small"
        backgroundColor="background.primary"
      >
        {/* Editorial measure: cap content width and center, so wide screens get
            a stable reading column instead of two-column layouts (rail + main)
            sprawling across 1700px+ with empty space between cards. The bg fill
            stays on the outer View so the cream extends edge-to-edge. */}
        <View maxWidth="1400px" margin="0 auto">
          <GlobalMessage />
          <Modal />
          <Outlet />
        </View>
      </View>
      <View columnStart={isDesktop ? '2' : '1'} rowStart="3">
        {baseConfig.footer && <Footer />}
      </View>
    </Grid>
  );
};

export default Layout;
